import { render, staticRenderFns } from "./AddAdminUser.vue?vue&type=template&id=634f7754&"
import script from "./AddAdminUser.vue?vue&type=script&lang=js&"
export * from "./AddAdminUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports